import React, { useEffect, useState } from "react";
import { api, formatApiError, fmtMXN, fmtDate } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus } from "lucide-react";
import { toast } from "sonner";

export default function Gastos() {
  const [gastos, setGastos] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ concepto: "", categoria: "General", monto: 0, nota: "" });
  const load = () => api.get("/gastos").then((r) => setGastos(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.concepto || !form.monto) return toast.error("Concepto y monto requeridos");
    try {
      await api.post("/gastos", { ...form, monto: parseFloat(form.monto) });
      toast.success("Gasto registrado");
      setOpen(false); setForm({ concepto: "", categoria: "General", monto: 0, nota: "" }); load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const total = gastos.reduce((s, g) => s + g.monto, 0);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center flex-wrap gap-2">
        <div><h2 className="text-3xl font-black tracking-tight">Gastos</h2><p className="text-sm text-muted-foreground mt-1">Total registrado: <span className="font-bold text-foreground">{fmtMXN(total)}</span></p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button><Plus className="h-4 w-4 mr-1" />Nuevo gasto</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Registrar gasto</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Concepto *</Label><Input value={form.concepto} onChange={(e) => setForm({ ...form, concepto: e.target.value })} /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Categoría</Label><Input value={form.categoria} onChange={(e) => setForm({ ...form, categoria: e.target.value })} /></div>
                <div><Label>Monto *</Label><Input type="number" step="0.01" value={form.monto} onChange={(e) => setForm({ ...form, monto: e.target.value })} /></div>
              </div>
              <div><Label>Nota</Label><Textarea value={form.nota} onChange={(e) => setForm({ ...form, nota: e.target.value })} /></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button><Button onClick={save}>Guardar</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <Card>
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow><TableHead>Fecha</TableHead><TableHead>Concepto</TableHead><TableHead>Categoría</TableHead><TableHead className="text-right">Monto</TableHead></TableRow>
            </TableHeader>
            <TableBody>
              {gastos.map((g) => (
                <TableRow key={g.id}>
                  <TableCell>{fmtDate(g.fecha)}</TableCell>
                  <TableCell className="font-semibold">{g.concepto}</TableCell>
                  <TableCell>{g.categoria}</TableCell>
                  <TableCell className="text-right font-bold">{fmtMXN(g.monto)}</TableCell>
                </TableRow>
              ))}
              {gastos.length === 0 && <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground py-8">Sin gastos</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
